import React from 'react';

// This is a textarea which grows in height upon hitting the enter key.
// Set an initial row height and max row height with initialRows and maxRows.
// If not passed as props, they will be defined as 2 and 12 respectively.

// Pressing a meta key (cmd, windows, etc) along with enter will call a provided
// submit handler.
const GrowingTextarea = React.createClass({
  getInitialState: function() {
    const initialRows   = this.props.initialRows || 2;
    const maxRows       = this.props.maxRows || 12;
    const initialHeight = this.getHeightPx(initialRows)
    return {
      initialRows: initialRows,
      maxRows,
      activeRows: 1,
      style: {
        height: initialHeight
      }
    }
  },
  render: function() {
    const maxLength = this.props.maxLength || 500;
    return (
      <textarea
        className="growing-textarea"
        placeholder={this.props.placeholder}
        value={this.props.textareaValue}
        onKeyDown={this.handleKeyDown}
        onChange={this.props.handleCommentChange}
        style={this.state.style}
        disabled={this.props.isDisabled}
        ref="commentTextarea"
        maxLength={maxLength}
      />
    );
  },
  componentDidUpdate(prevProps, prevState) {
    // Scroll the textarea to bottom on update
    const node = this.refs.commentTextarea;
    node.scrollTop = node.scrollHeight;
  },
  getHeightPx(rows) {
    return `${(rows * 18) + 24}px`;
  },
  handleKeyDown: function(e) {
    if (e.keyCode == 13) {
      if (e.metaKey) {
        // Submit if metaKey (cmd/windows) is held along with enter
        this.props.handleSubmit(e);
        return;
      }
      const { initialRows, activeRows, maxRows } = this.state;
      const newRows = activeRows + 1;
      this.setState({
        activeRows: newRows
      });
      if (newRows <= maxRows && newRows >= initialRows) {
        // Grow textarea if enter key is pressed
        this.setState({
          activeRows: newRows,
          style: {
            height: this.getHeightPx(newRows)
          }
        });
      }
    }
  }
})

export default GrowingTextarea;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/common/components/growing-textarea.es6